import { CountryCode, getCountries, getCountryCallingCode } from 'libphonenumber-js'
type PhoneableCountryCode = CountryCode
const getPhoneableCountryCodes = getCountries

export { PhoneableCountryCode, getPhoneableCountryCodes, getCountryCallingCode }
